module.exports = __webpack_public_path__ + "img/BHD.f6e98cbd.svg";